export enum Indexes {
    SIRE = "SIRE",
    CONSIGNOR = "CONSIGNOR",
    DAM = "DAM"
}

export const IndexesFriendlyName = (index: Indexes): string => {
    switch (index) {
        case Indexes.SIRE:
            return "Index by Sire";
        case Indexes.CONSIGNOR:
            return "Index by Consignor";
        case Indexes.DAM:
            return "Index by Dam";
        default:
            return "?";
    }
};

export const IndexesRequestName = (index: string): string => {
    switch (index) {
        case "SIRE":
            return "index-by-sire";
        case "CONSIGNOR":
            return "index-by-consignor";
        case "DAM":
            return "index-by-dam";
        default:
            return "?";
    }
};



// WEBPACK FOOTER //
// ./src/model/Reports.ts